// @needs-native-review — best-effort translation
import type { ChromeTranslations } from '../types';

export const zh: ChromeTranslations = {
  'nav.nextPage': '下一页 →',
  'nav.previousPage': '← 上一页',
  'nav.continueToLevel': '继续进入关卡 →',
  'nav.backToMenu': '返回菜单 →',
  'howto.page': '第 {n} 页,共 {total} 页',
  'options.title': '选项',
  'ui.language': '语言',
};
